import { requests } from '../../helper/agent';
import { SubmissionError } from 'redux-form';
import {
  CONSULTANT_SPECIALITY_LIST_REQUEST,
  CONSULTANT_SPECIALITY_LIST_RECEIVED,
  CONSULTANT_SPECIALITY_LIST_ERROR,
  CONSULTANT_SPECIALITY_SINGLE_CREATE_REQUEST,
  CONSULTANT_SPECIALITY_SINGLE_CREATE_SUCCESS,
} from '../constants';

import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { parseApiErrors } from '../../helper/apiUtils';

export const consultantSpecialityListRequest = () => ({
  type: CONSULTANT_SPECIALITY_LIST_REQUEST,
});

export const consultantSpecialityListReceived = (data) => ({
  type: CONSULTANT_SPECIALITY_LIST_RECEIVED,
  data,
});

export const consultantSpecialityListError = (error) => ({
  type: CONSULTANT_SPECIALITY_LIST_ERROR,
  error,
});

export const consultantSpecialitySingleCreateRequest = () => ({
  type: CONSULTANT_SPECIALITY_SINGLE_CREATE_REQUEST,
});

export const consultantSpecialitySingleCreateSuccess = (data) => ({
  type: CONSULTANT_SPECIALITY_SINGLE_CREATE_SUCCESS,
  data,
});

export const consultantSpecialitySingleCreate = (data) => {
  return (dispatch) => {
    dispatch(consultantSpecialitySingleCreateRequest());
    return requests
      .post(API_ROUTES.CONSULTANT_SPECIALITY, { name: data })
      .then((response) => {
        dispatch(consultantSpecialitySingleCreateSuccess(response));
        return response;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

export const consultantSpecialityListFetch = () => {
  return (dispatch) => {
    dispatch(consultantSpecialityListRequest());
    const filters = { pagination: false };
    return requests
      .get(API_ROUTES.CONSULTANT_SPECIALITY, filters)
      .then((response) => dispatch(consultantSpecialityListReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(consultantSpecialityListError(error));
      });
  };
};
